var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$companyConfiguration.evaluation.isEnabled())?_c('div',[_c('page-heading',{attrs:{"heading":"Мои оценки 360"}}),_c('el-card',[_c('my-evaluations-component',{ref:"myEvaluationsComponent"})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }